import { Typography } from '@mui/material';
import React from 'react';
import EllipsisText from '../../common/components/EllipsisText';
import { V } from '../../common/Layout';
import { useStyling } from '../../common/Theme';
import { Field, TermsetField } from '../attributes';
import TypePreview from '../TypePreview';

type TermsetFieldPreviewProps = {
    field: Field;
    onClick?: (field) => void;
};

export default (props: TermsetFieldPreviewProps) => {
    const { field, onClick } = props;
    const { theme } = useStyling();
    const cast = field as TermsetField;

    return (
        <V onClick={onClick}>
            <TypePreview type={field.fieldType} />
            <EllipsisText text={field.label} sx={{ width: '140px' }} />
            <EllipsisText
                text={field.description}
                clampLines={2}
                sx={{ fontSize: 'smaller', color: theme.palette.text.disabled }}
            />
            <Typography>{cast.termset}</Typography>
        </V>
    );
};
